import React, { useState } from "react";
import { toast } from "sonner";
import { Field, Input, Textarea, Select, SubmitButton } from "./FormPrimitives";
import { FormSuccess } from "./FormSuccess";
import { submitContact } from "../../lib/api";

const initial = { name: "", email: "", phone: "", reason: "", message: "" };

export const ContactForm = ({ defaultReason = "" }) => {
  const [form, setForm] = useState({ ...initial, reason: defaultReason });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);

  const set = (k, v) => { setForm((f) => ({ ...f, [k]: v })); setErrors((e) => ({ ...e, [k]: undefined })); };

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Please enter your name.";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Please enter a valid email.";
    if (!form.reason) e.reason = "Please choose a reason.";
    if (!form.message.trim()) e.message = "Please add a short message.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = async (ev) => {
    ev.preventDefault();
    if (!validate()) { toast.error("Please review the highlighted fields."); return; }
    setLoading(true);
    try {
      const res = await submitContact(form);
      setDone(res);
      toast.success("Message sent.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <FormSuccess
        testid="contact-success"
        title="Message sent."
        message={done.message}
        refId={done.ref_id}
        onReset={() => { setForm({ ...initial, reason: defaultReason }); setDone(null); }}
      />
    );
  }

  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 gap-6" data-testid="contact-form" noValidate>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Field label="Name" required htmlFor="c_name" error={errors.name}>
          <Input id="c_name" data-testid="contact-name" value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Full name" />
        </Field>
        <Field label="Email" required htmlFor="c_email" error={errors.email}>
          <Input id="c_email" type="email" data-testid="contact-email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="you@email.com" />
        </Field>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Field label="Phone" htmlFor="c_phone" hint="Optional">
          <Input id="c_phone" data-testid="contact-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="(000) 000-0000" />
        </Field>
        <Field label="Reason for contact" required htmlFor="c_reason" error={errors.reason}>
          <Select id="c_reason" data-testid="contact-reason" value={form.reason} onChange={(e) => set("reason", e.target.value)}>
            <option value="">Select…</option>
            <option>Donate</option>
            <option>Volunteer</option>
            <option>Partner</option>
            <option>General Question</option>
          </Select>
        </Field>
      </div>
      <Field label="Message" required htmlFor="c_message" error={errors.message}>
        <Textarea id="c_message" data-testid="contact-message" value={form.message} onChange={(e) => set("message", e.target.value)} placeholder="How can we help?" />
      </Field>
      <div><SubmitButton loading={loading} testid="contact-submit">Contact Iron Shield</SubmitButton></div>
    </form>
  );
};

export default ContactForm;
